import { Clock } from 'lucide-react'
import React, { useContext, useEffect, useState } from 'react'
import { Link, useParams } from 'react-router'
import { BASE_URL_API } from '../../../References/URLs'
import ActiveStoreContext from '../../../store/ActiveStoreContext'
import AuthContext from '../../../store/auth-context'
import styles from './LbEfWrapper.module.css'

const LbEfWrapper = () => {
    const { formIdentifier } = useParams()
    const authCtx = useContext(AuthContext)
    const asCtx = useContext(ActiveStoreContext)

    const activeStore = (() => {
        try {
            return asCtx?.activeStore && asCtx.activeStore.trim() !== "" ? JSON.parse(asCtx.activeStore) : null
        } catch {
            return null
        }
    })()

    const vendorIdentifier = JSON.parse(authCtx?.loginData)?.partnersData?.vendorIdentifier
    const [formData, setFormData] = useState(null)

    const lb_getFormData = async () => {
        try {
            const response = await fetch(BASE_URL_API + "lb_getFormData", {
                method: "POST",
                body: JSON.stringify({
                    token: authCtx.token,
                    formIdentifier: formIdentifier
                })
            })

            if (!response.ok) {
                console.log("Something went wrong : Server Error")
                return
            }

            const respo = await response.json()

            if (respo.status === "success") {
                setFormData(respo.response)
            } else {
                if (respo.message === "tokenExpired") {
                    authCtx.logout()
                }
            }

            console.log(respo)
        } catch (err) {
            console.error("Error while fetching form data", err)
        }
    }

    useEffect(() => {
        lb_getFormData()
    }, [])

    const excludedKeys = [
        "vendorIdentifier",
        "storeIdentifier",
        "formIdentifier",
        "source_url",
        "ip_address",
        "user_agent",
        "form_type"
    ]

    const getFilteredSampleKeys = (leadsArray) => {
        if (!Array.isArray(leadsArray)) return []

        for (let lead of leadsArray) {
            try {
                const raw = lead?.entireFormData
                const parsed = typeof raw === 'string' ? JSON.parse(raw) : raw

                if (parsed && typeof parsed === 'object' && !Array.isArray(parsed)) {
                    return Object.keys(parsed).filter(key => !excludedKeys.includes(key))
                }
            } catch (err) {
                console.warn("Invalid JSON in lead.entireFormData", err)
            }
        }

        return []
    }

    const sampleKeys = getFilteredSampleKeys(formData?.leads)

    if (!activeStore) {
        return <div className={styles.wrapper}>Please select a store.</div>
    }

    if (!formData) {
        return <div className={styles.wrapper}>Loading...</div>
    }

    return (
        <div className={styles.wrapper}>
            <div className={styles.pageHeader}>
                <Link to={`/leadbridge`} className={styles.phlWrapper}>
                    LeadBridge™
                </Link>
                <div className={styles.phrWrapper}>
                    <Link to={`/leadbridge/get-started/create-form`}>
                        Create Form
                    </Link>
                    <Link to={`/leadbridge/help`}>
                        Help
                    </Link>
                </div>
            </div>

            <div className={styles.container}>
                <div className={styles.metaInfo}>
                    <div><strong>Form Name:</strong> {formData?.formData?.formName}</div>
                    <p><strong>Page URL:</strong> {formData?.formData?.pageUrl}</p>
                    <p><strong>Form ID:</strong> {formData?.formData?.formIdentifier}</p>
                    <p><strong>Created On:</strong> {formData?.formData?.createdOn}</p>
                </div>

                <div className={styles.cardList}>
                    <div className={styles.cardHeaders}>
                        {sampleKeys.map((key, idx) => (
                            <div key={idx} className={styles.cardHeader}>
                                {key.replace(/([A-Z])/g, ' $1')}
                            </div>
                        ))}
                    </div>

                    {formData?.leads?.length > 0 ? (
                        <div className={styles.formDataWrapper}>
                            {formData?.leads?.map((data, index) => {
                                let parsedData = {};
                                try {
                                    parsedData = typeof data?.entireFormData === 'string'
                                        ? JSON.parse(data.entireFormData)
                                        : data.entireFormData;
                                } catch (e) {
                                    console.warn("Failed to parse lead data", e)
                                }

                                return (
                                    <div key={index} className={styles.leadRowCard}>
                                        <div className={styles.leftMeta}>
                                            <Clock size={16} />
                                            <span>{data.submittedOn}</span>
                                        </div>
                                        <div className={styles.fieldsRow}>
                                            {sampleKeys.map((key, idx) => (
                                                <div key={idx} className={styles.fieldValueOnly}>
                                                    {parsedData?.[key] ?? "-"}
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                )
                            })}
                            <div className={styles.endMessage}>That's all!</div>
                        </div>
                    ) : (
                        <p>No leads found for this form.</p>
                    )}
                </div>

            </div>
        </div>
    )
}

export default LbEfWrapper
